import {
    CORE_GET_ALL_COURSE_REQUEST,
    CORE_GET_ALL_COURSE_SUCCESS,
    CORE_GET_ALL_COURSE_FAILURE,

    CORE_GET_COURSE_BY_ID_REQUEST,
    CORE_GET_COURSE_BY_ID_SUCCESS,
    CORE_GET_COURSE_BY_ID_FAILURE,

    CORE_GET_ALL_COURSE_WAITING_APPROVE_REQUEST,
    CORE_GET_ALL_COURSE_WAITING_APPROVE_SUCCESS,
    CORE_GET_ALL_COURSE_WAITING_APPROVE_FAILURE,

    CORE_GET_COURSE_REQUEST_TO_JOIN_REQUEST,
    CORE_GET_COURSE_REQUEST_TO_JOIN_SUCCESS,
    CORE_GET_COURSE_REQUEST_TO_JOIN_FAILURE,

    CORE_GET_COURSE_REQUEST_TO_JOIN_BY_ID_REQUEST,
    CORE_GET_COURSE_REQUEST_TO_JOIN_BY_ID_SUCCESS,
    CORE_GET_COURSE_REQUEST_TO_JOIN_BY_ID_FAILURE,

    CORE_GET_COURSE_INCOMING_BY_ID_REQUEST,
    CORE_GET_COURSE_INCOMING_BY_ID_SUCCESS,
    CORE_GET_COURSE_INCOMING_BY_ID_FAILURE,


} from '../../settingsType'
import { REQUEST_STATE } from '../../types'

const requestState = REQUEST_STATE

export default {
    courses: (state = requestState, action) => {
        switch (action.type) {
            case CORE_GET_ALL_COURSE_REQUEST:
            case CORE_GET_ALL_COURSE_WAITING_APPROVE_REQUEST:
            case CORE_GET_COURSE_REQUEST_TO_JOIN_REQUEST:
                return state
            case CORE_GET_ALL_COURSE_SUCCESS:
            case CORE_GET_ALL_COURSE_WAITING_APPROVE_SUCCESS:
            case CORE_GET_COURSE_REQUEST_TO_JOIN_SUCCESS:
                if (action.payload) {
                    console.log(action.payload)
                    const { result, datas } = action.payload
                    if (result && datas) {
                        return datas
                    } else return []
                } else {
                    return []
                }
            case CORE_GET_ALL_COURSE_FAILURE:
            case CORE_GET_ALL_COURSE_WAITING_APPROVE_FAILURE:
            case CORE_GET_COURSE_REQUEST_TO_JOIN_FAILURE:
                return []
            default:
                return state
        }
    },
    course: (state = requestState, action) => {
        switch (action.type) {
            case CORE_GET_COURSE_BY_ID_REQUEST:
            case CORE_GET_COURSE_REQUEST_TO_JOIN_BY_ID_REQUEST:
            case CORE_GET_COURSE_INCOMING_BY_ID_REQUEST:
                return state
            case CORE_GET_COURSE_BY_ID_SUCCESS:
            case CORE_GET_COURSE_REQUEST_TO_JOIN_BY_ID_SUCCESS:
            case CORE_GET_COURSE_INCOMING_BY_ID_SUCCESS:
                if (action.payload) {
                    const { result, data } = action.payload
                    if (result && data) {
                        return data
                    } else return {}
                } else {
                    return {}
                }
            case CORE_GET_COURSE_BY_ID_FAILURE:
            case CORE_GET_COURSE_REQUEST_TO_JOIN_BY_ID_FAILURE:
            case CORE_GET_COURSE_INCOMING_BY_ID_FAILURE:
                return {}
            default:
                return state
        }
    },

}


// WEBPACK FOOTER //
// ./src/app/redux/reducers/settings/course.js